import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { Button } from '@mui/material';
import { useSetAtom } from 'jotai';
import { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { captureFormValidationError } from '../../../../util/SentryUtils';
import { currentScenarioStateJ } from '../../../../services/state/ScenariosStateJ';
import { useScenarioActions } from '../hooks/useScenarioActions';
import { prepareScenarioPayload } from './form/scenarioFormUtils';

export const RunScenarioAction: FC = () => {
  const { handleValidateAndRun } = useValidateAndRun();

  return (
    <Button
      type='button'
      onClick={handleValidateAndRun}
      variant='contained'
      size='medium'
      color='secondary'
      startIcon={<PlayArrowIcon />}
    >
      Run Scenario
    </Button>
  );
};

export function useValidateAndRun() {
  const formContext = useFormContext();
  const setCurrentScenario = useSetAtom(currentScenarioStateJ);
  const { handleRunScenario } = useScenarioActions();

  const handleValidateAndRun = useCallback(async () => {
    if (!formContext) {
      return handleRunScenario();
    }
    const {
      getValues,
      trigger,
      formState: { errors },
    } = formContext;
    const isValid = await trigger();
    if (!isValid) {
      captureFormValidationError('Scenario run', errors);
      return;
    }
    const values = getValues();
    const payload = prepareScenarioPayload(values);
    setCurrentScenario(payload);
    handleRunScenario();
  }, [formContext, handleRunScenario, setCurrentScenario]);

  return { handleValidateAndRun };
}
